import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d2c235f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sync-app-page container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Use the Sync app to upload your tree", -1))
const _hoisted_3 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_4 = { class: "gen-apps" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Supported genealogy programs:", -1))
const _hoisted_6 = { class: "more-info" }

import { usePageTitle } from '@/util/AppUtil'
import { currentOS } from '@/rd/ResearchDataModel'
import SyncAppTile from '@/sync/SyncAppTile.vue'
import AppSupportGrid from './AppSupportGrid.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncAppPage',
  setup(__props) {

usePageTitle('Get the Sync app')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_unref(currentOS))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " The Sync app works with desktop genealogy programs. The app is available on Windows and MacOS. "))
      : _createCommentVNode("", true),
    _createVNode(SyncAppTile),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(AppSupportGrid)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, { to: { name: 'sync' } }, {
        default: _withCtx(() => [
          _createTextVNode("Learn more about the Sync app")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})